<template>
  <div>
    <hot-pc
    class="display-pc"
    :hotTopicsArr="hotTopicsArr"
    :lectures="lectures"
    :appliededHotLecturesArr="hotLecturesArr"
    :hotProducers="hotProducers"
    :hotSpeakers="hotSpeakers"
    ></hot-pc>
    <hot-m class="display-m" :tracks="tracks"></hot-m>
  </div>
</template>
<script>
import hotPc from './hot-pc.vue'
import hotM from './hot-m.vue'

/**
 * 往届热门专题推荐组件
 */
export default {
  data () {
    return {}
  },
  components: {
    hotPc,
    hotM
  },
  computed: {
    hotTopicsArr () {
      return this.$store.state.hotTopicsArr
    },
    lectures () {
      return this.$store.state.lectures
    },
    hotLecturesArr () {
      return this.$store.state.hotLecturesArr
    },
    hotProducers () {
      return this.$store.state.guestsArr.filter(item => Number(item.typeId) === 3)
    },
    hotSpeakers () {
      return this.$store.state.guestsArr.filter(item => Number(item.typeId) !== 3)
    },
    pastPre () {
      return this.$store.state.isPastHot === 1 ? '往届' : ''
    },
    tracks () {
      let arr = []
      if (this.hotTopicsArr.length) {
        arr.push({ id: 0, title: this.pastPre + '热门专题', data: this.hotTopicsArr })
      }
      if (this.hotLecturesArr.length) {
        arr.push({ id: 1, title: this.pastPre + '热门议题', data: this.hotLecturesArr })
      }
      if (this.hotProducers.length) {
        arr.push({ id: 2, title: this.pastPre + '优秀出品人', data: this.hotProducers })
      }
      if (this.hotSpeakers.length) {
        arr.push({ id: 3, title: this.pastPre + '明星讲师', data: this.hotSpeakers })
      }
      return arr
    }
  }
}
</script>
